/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import $ from 'jquery';
import _ from 'underscore';
import { CampaignBidLandscape } from '@bingads-webui/bid-landscape';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { showPopup } from '@bingads-webui/automatic-positioning-popover';
import { Dialog } from '@bingads-webui/dialog';
import { ProgressView } from '@bingads-webui-campaign/campaigns-landscape-progress';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import appConfig from '@bingads-webui-component-legacy/config/index';
import jsdataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import { schema as instruSchema } from '../instrumentation-schema';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');

let dialog = {};
let dialogProgress = {};
let bulkEditChange = {};

const ACTION_TYPE = {
  CampaignWideBid: 'SetToAmount',
  BidScaling: 'ChangeByPercent',
  TROAS: 'TargetROAS',
  TCPA: 'TargetCPA',
};
const currencyCode = appConfig.get('AccountCurrencyCode');
instrumentation.addScenario(instruSchema);
const senario = instrumentation.campaignLandscapeEditBid.create();
const activity = senario.campaignLandscapeEditBid.create();
activity.start();

export function campaignBidLandscapeTrack(options) {
  const {
    Id,
    scope,
    landscapeType,
    hash,
    callback,
  } = options;
  const { customerId: cid, accountId: aid } = scope;
  const url = `Customers(${cid})/Accounts(${aid})/Campaigns(${Id})/CampaignBidLandscape.Track`;
  return odata.post(
    url,
    {
      path: 'AdInsight/V2/',
      host: 'adinsight.odata.url',
      data: {
        Request: {
          Type: landscapeType,
          Hash: hash,
        },
      },
    }
  ).then(() => callback());
}

function showError(msg) {
  const alertHelper = new AlertHelper({ i18n });
  alertHelper.showError(msg);
}

export function applyError(response) {
  let error;
  const unexpectedError = i18n.getString('ErrorNumber_-1');

  if (!response || !response.errors) {
    error = unexpectedError;
  } else {
    const errors = i18nErrors.getBulkApiErrors(response.errors, 'newadgroup')
      || i18nErrors.getBulkApiErrors(response.errors, 'newkeyword');

    if (!errors || !errors[0] || !errors[0].message) {
      error = unexpectedError;
    } else {
      error = errors[0].message;
    }
  }
  showError(error);
}

export function validateSearchBid(newBidStr, campaignSelectMode) {
  const bidRange = appConfig.get('KeywordBidRange');
  let floorPrice = bidRange.FloorValue || 0.01;
  let ceilingPrice = bidRange.CeilingValue || 1000;

  if (campaignSelectMode === 'TCPA') {
    ceilingPrice *= 4;
  } else if (campaignSelectMode === 'TROAS') {
    floorPrice = 0.01;
    ceilingPrice = 1000;
  }

  let floorPriceStr = i18n.formatDecimalToFixed(campaignSelectMode === 'TROAS' ? floorPrice * 100 : floorPrice);
  let ceilingPriceStr = i18n.formatDecimalToFixed(campaignSelectMode === 'TROAS' ? ceilingPrice * 100 : ceilingPrice);
  if (campaignSelectMode === 'BidScaling') {
    ceilingPrice = 100000;
    floorPrice = -90;
    ceilingPriceStr = `${ceilingPrice}%`;
    floorPriceStr = `${floorPrice}%`;
  }

  if (newBidStr < floorPrice) {
    return i18n.getString('AdGroupSummary_SearchBidLessThanFloorPrice').replace('#0#', floorPriceStr);
  } else if (newBidStr > ceilingPrice) {
    return i18n.getString('AdGroupSummary_SearchBidMoreThanCeilingPrice').replace('#0#', ceilingPriceStr);
  }
  return '';
}

export function getParams(options, entity) {
  const timeFormat = { raw: 'M/d/yyyy', timeZone: 'UTC' };
  const end = new Date();
  const start = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000));
  const startDate = i18n.formatDate(start, timeFormat);
  const endDate = i18n.formatDate(end, timeFormat);
  const QueryString = options.actionType === 'ChangeByPercent' && entity === 'Keyword' ?
    `startdate=${startDate}&enddate=${endDate}&$filter=Bid/AmountSource eq Enum.BidAmountSource'UseFromOrderItem'`
    : `startdate=${startDate}&enddate=${endDate}`;
  const Property = entity === 'AdGroup' ? 'SearchBid' : 'Bid/Amount';
  const Value = entity === 'Keyword' && options.actionType === 'SetToAmount' ? null : options.newValue;
  const params = {
    Entity: entity,
    BatchAction: {
      Actions: [{
        '@odata.type': '#Model.NumericAction',
        Property,
        ActionType: options.actionType,
        Value,
        Limit: null,
      },
      ],
    },
    Selection: {
      QueryString,
      CampaignId: options.Id,
      AdGroupId: null,
    },
    Description: null,
    PreviewCompositeIds: [],
  };
  return params;
}

function bulkEdit(options) {
  const paramsAdGroup = getParams(options.params, 'AdGroup');
  const paramsKeyword = getParams(options.params, 'Keyword');
  bulkEditChange(_.defaults(
    {
      params: paramsAdGroup,
      completeCB: (res) => {
        options.progressCB(res);
        bulkEditChange(_.defaults(
          { params: paramsKeyword },
          _.pick(options, 'completeCB', 'progressCB', 'failedCB')
        ));
      },
    },
    _.pick(options, 'progressCB', 'failedCB')
  ));
}

// Going
function defaultApply(campaign, campaignBidLandscapeView, scope, grid, noWidBidData, trackingId) {
  const {
    Id,
  } = campaign;
  const newValue = campaignBidLandscapeView.valueToApply();
  const landscapeType = campaignBidLandscapeView.campaignSelectMode();
  const hash = campaignBidLandscapeView.hash();
  const actionType = ACTION_TYPE[landscapeType];
  const additionalBuget = campaignBidLandscapeView.keepCurrentBudget() ?
    null : campaignBidLandscapeView.additionalBuget();
  const currentBudget = campaign.Budget.Amount;
  const startDate = campaignBidLandscapeView.viewModel.startDateString();
  const endDate = campaignBidLandscapeView.viewModel.endDateString();
  const isCustomBid = campaignBidLandscapeView.viewModel.currentSelectedId()
                      === campaignBidLandscapeView.viewModel.landscapePointsLength();
  const selectedData = isCustomBid ? {} : campaignBidLandscapeView.viewModel.dataArray()[campaignBidLandscapeView.viewModel.currentSelectedId()];
  const curValue = landscapeType === 'TCPA' || landscapeType === 'TROAS' ? campaign.BiddingScheme[campaign.BiddingScheme.Type] : null;
  let campaignData = campaign;

  dialog.remove();
  if (landscapeType === 'TCPA' || landscapeType === 'TROAS') {
    const toUpdated = {
      BiddingScheme: { ...campaign.BiddingScheme },
    };
    toUpdated.BiddingScheme[toUpdated.BiddingScheme.Type] = newValue;
    jsdataCampaign.Campaign
      .update(campaign.Id, toUpdated, { adapter: 'bulk', cacheResponse: false })
      .finally(withUiBlock(grid.gridView.$el))
      .then(() => {
        grid.gridView.refresh(true);
      })
      .catch(response => applyError(response));
  } else {
    const progressView = new ProgressView({
      scope,
      i18n,
    });
    dialogProgress = new Dialog({
      backdrop: true,
      keyboard: true,
      showCloseButton: false,
    }).setContent(progressView);
    $(document.body).append(dialogProgress.el);
    dialogProgress.show();
    progressView.on('close', () => dialogProgress.remove());

    bulkEdit({
      params: {
        newValue,
        actionType,
        Id,
      },
      completeCB: () => {
        setTimeout(() => dialogProgress.remove(), 500);
      },
      failedCB: (res) => {
        applyError(res);
        dialogProgress.remove();
      },
      progressCB: () => { },
    });
  }

  campaignBidLandscapeTrack({
    Id,
    scope,
    landscapeType,
    hash,
    callback: () => {
      campaignData = _.defaults({ IsBidLandscapeAvailable: !noWidBidData }, campaignData);
      grid.gridView.trigger('didEdit', campaignData);
    },
  });
  if (additionalBuget) {
    if (campaign.Budget.Id) {
      const updated = _.defaults({
        Amount: additionalBuget,
      });
      jsdataCampaign.Budget.update(campaign.Budget.Id, updated, { adapter: 'bulk', cacheResponse: false })
        .then(() => {
          campaignData = _.defaults({ Budget: _.defaults(updated, campaign.Budget) }, campaignData);
          grid.gridView.trigger('didEdit', campaignData);
        })
        .catch((response) => {
          applyError(response, 'bulk');
        });
    } else {
      const updated = _.defaults({
        Budget: { Amount: additionalBuget },
      }, _.pick(campaign, 'Id'));
      jsdataCampaign.Campaign.update(campaign.Id, updated, { adapter: 'bulk', cacheResponse: false })
        .then(() => {
          campaignData = _.defaults(
            {
              Budget: _.defaults(updated.Budget, campaign.Budget),
            },
            campaignData
          );
          grid.gridView.trigger('didEdit', campaignData);
        })
        .catch((response) => {
          applyError(response, 'bulk');
        });
    }
  }
  activity.trace(`Apply Campaign bid landscape success for ${campaign.Id}: ${newValue}. Currency:${currencyCode}. LandscapeType: ${landscapeType}. IncreaseBudget: ${additionalBuget}. CurrentBudget: ${currentBudget}. DataDate: ${startDate}~${endDate}. TrackingId: ${trackingId}. IsCustomBid: ${isCustomBid}. CurValue: ${curValue}. EstImp: ${selectedData.impressions}. EstTopImp: ${selectedData.mlImpressions}. EstClick: ${selectedData.clicks}. EstSpend: ${selectedData.cost}. EstConv: ${selectedData.conversion}. EstConvValue: ${selectedData.conversionValue}. AdditionalBudgetNeeded: ${selectedData.additionalBugetNeeds}.`, 'campaignLandscapeEditBid');
}

export function formatRes(data, Id) {
  const res = { Id, Nodata: true };
  data.value.forEach((val) => {
    if (val.BidLandscapePoints && val.BidLandscapePoints.length > 0) {
      res[val.CampaignBidLandscapeType] = val;
      res.Nodata = false;
    }
  });
  return res;
}

function onCallReturnedForBidLandscape({
  campaign, response, event, scope, container, isForVNext, grid, perfMarker,
}) {
  const dataToShow = formatRes(response, campaign.Id);
  const noWidBidData = _.isUndefined(dataToShow.CampaignWideBid);
  const trackingId = generateGuid();
  const currentTargetValue = campaign.BiddingScheme[campaign.BiddingScheme.Type];
  const campaignBidLandscapeView = new CampaignBidLandscape({
    parentItem: {
      Id: campaign.Id,
      CurrentValue: campaign.Budget.Amount.toString(),
      CurrentTargetValue: currentTargetValue,
      EntityName: campaign.Name,
      CurrencyCode: currencyCode,
    },
    i18n,
    dataToShow,
    isForVNext,
  });

  campaignBidLandscapeView.on('cancel', () => {
    dialog.remove();
  });

  campaignBidLandscapeView.on('apply', () => {
    defaultApply(campaign, campaignBidLandscapeView, scope, grid, noWidBidData, trackingId);
  });

  campaignBidLandscapeView.on('update', ({ valueToApply }) => {
    const campaignSelectMode = campaignBidLandscapeView.campaignSelectMode();
    campaignBidLandscapeView.markInputValueInvalid(validateSearchBid(
      valueToApply,
      campaignSelectMode
    ));
  });

  campaignBidLandscapeView.once('selectModeChange rendered', () => {
    const showActivity = senario.FetchedCampaignBidLandscape.create();
    showActivity.start();
    const ariaData = {
      Id: campaign.Id,
      ActionName: 'ViewCampaignBidLandscape',
      UIData: {
        selectMode: campaignBidLandscapeView.campaignSelectMode(),
        bidList: campaignBidLandscapeView.viewModel.dataArray(),
        currencyCode,
        currentBudget: campaign.Budget.Amount,
        startDate: campaignBidLandscapeView.viewModel.startDateString(),
        endDate: campaignBidLandscapeView.viewModel.endDateString(),
        trackingId,
      },
    };
    showActivity.trace(ariaData, 'ViewCampaignBidLandscape');
  });

  campaignBidLandscapeView.render();
  if (campaignBidLandscapeView.hasData()) {
    dialog = new Dialog({
      backdrop: true,
      keyboard: true,
      showCloseButton: false,
    }).setContent(campaignBidLandscapeView).setState({
    }).render();
    $(dialog.el).addClass('fix-dialog-position');
    $(document.body).append(dialog.el);
    dialog.show();
  } else {
    showPopup({
      positioningMethod: 'fit',
      positioningOptions: {
        anchorPosition: {
          top: event.clientY,
          left: event.clientX,
          width: $(event.target).width(),
          height: $(event.target).height(),
        },
      },
      contentView: campaignBidLandscapeView,
      i18n,
      classes: ['bidlandscape-container'],
      container,
      anchor: $(event.target),
    });
  }

  if (perfMarker) {
    perfMarker.done();
  }
}

export function openCampaignBidLandscape({
  event, scope, campaign, grid, container, isForVNext, bulkChange, perfMarker,
}) {
  activity.trace(`Fetch Campaign bid landscape success for ${campaign.Id}`, 'campaignLandscapeEditBid');
  const uiBlocker = withUiBlock(grid.gridView.$el.parent());
  const { customerId: cid, accountId: aid } = scope;
  bulkEditChange = bulkChange;

  if (perfMarker) {
    perfMarker.willFetchData();
  }

  const url = `Customers(${cid})/Accounts(${aid})/Campaigns(${campaign.Id})/CampaignBidLandscape.GetDetails`;

  return odata.get(url, {
    path: 'AdInsight/V2/',
    host: 'adinsight.odata.url',
  })
    .then((response) => {
      if (perfMarker) {
        perfMarker.willRender();
      }

      onCallReturnedForBidLandscape({
        grid, campaign, response, event, scope, container, isForVNext, perfMarker,
      });
      uiBlocker();
    });
}
